import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

const Main = (props) => {
  const allowedGroups = ["Главная"];
  return (
    <>
      {allowedGroups.every((allow) => props.permissions.includes(allow)) && (
        <li className="my-item">
          <Link to="/home">
            <i className="fa-solid fa-table-columns"></i>
            <span className="my-link_name">Главная</span>
          </Link>
        </li>
      )}
    </>
  );
};

const Analitika = (props) => {
  const allowedGroups = ["Аналитика"];
  const [show, setShow] = useState(false);
  return (
    <>
      {allowedGroups.every((allow) => props.permissions.includes(allow)) && (
        <li className={show ? "my-item showMenu" : "my-item"}>
          <div className="my-icon-link">
            <Link to="/">
              <i className="fa-solid fa-chart-bar"></i>
              <span className="my-link_name">Аналитика</span>
            </Link>
            <i
              className="fa-solid fa-chevron-down my-arrow"
              onClick={() => setShow(!show)}
            ></i>
          </div>
          <ul className="my-sub-menu">
            <li>
              <Link className="my-link_name" to="/">
                Аналитика
              </Link>
            </li>
            <li>
              <Link to="/">Dashboard</Link>
            </li>
            <li>
              <Link to="/">Продукты</Link>
            </li>
            <li>
              <Link to="/">Продажи</Link>
            </li>
            <li>
              <Link to="/filters">Фильтры</Link>
            </li>
            <li>
              <Link to="/survey">Опросы</Link>
            </li>
          </ul>
        </li>
      )}
    </>
  );
};

const Admin = (props) => {
  const allowedGroups = ["Админ"];
  const [show, setShow] = useState(false);
  return (
    <>
      {allowedGroups.every((allow) => props.permissions.includes(allow)) && (
        <li className={show ? "my-item showMenu" : "my-item"}>
          <div className="my-icon-link">
            <Link to="/">
              <i className="fa-regular fa-user"></i>
              <span className="my-link_name">Админ</span>
            </Link>
            <i
              className="fa-solid fa-chevron-down my-arrow"
              onClick={() => setShow(!show)}
            ></i>
          </div>
          <ul className="my-sub-menu">
            <li>
              <Link className="my-link_name" to="/">
                Админ
              </Link>
            </li>
            <li>
              <Link to="/roles">Роль</Link>
            </li>
            <li>
              <Link to="/admins">Сотрудник</Link>
            </li>
            <li>
              <Link to="/regions">Регион</Link>
            </li>
          </ul>
        </li>
      )}
    </>
  );
};

const Katalog = (props) => {
  const allowedGroups = ["Каталог"];
  const [show, setShow] = useState(false);

  return (
    <>
      {allowedGroups.every((allow) => props.permissions.includes(allow)) && (
        <li className={show ? "my-item showMenu" : "my-item"}>
          <div className="my-icon-link">
            <Link to="/">
              <i className="fa-solid fa-list"></i>
              <span className="my-link_name">Каталог</span>
            </Link>
            <i
              className="fa-solid fa-chevron-down my-arrow"
              onClick={() => setShow(!show)}
            ></i>
          </div>
          <ul className="my-sub-menu">
            <li>
              <Link className="my-link_name" to="/">
                Каталог
              </Link>
            </li>
            {props.permission && (
              <li>
                <Link to="/brands">Бренд</Link>
              </li>
            )}
            {props.permission && (
              <li>
                <Link to="/categories">Категория</Link>
              </li>
            )}
            {props.permission && (
              <li>
                <Link to="/collections">Коллекция</Link>
              </li>
            )}
            {props.permission && (
              <li>
                <Link to="/designs">Дизайн</Link>
              </li>
            )}
            {props.permission && (
              <li>
                <Link to="/formats">Формат</Link>
              </li>
            )}
            {props.permission && (
              <li>
                <Link to="/sizes">Размер</Link>
              </li>
            )}

            <li>
              <Link to="/units">Unit</Link>
            </li>

            <li>
              {props.permission && <Link to="/parameters">Параметры</Link>}
            </li>
          </ul>
        </li>
      )}
    </>
  );
};

const Logistika = (props) => {
  const allowedGroups = ["Логистика"];
  const [show, setShow] = useState(false);
  return (
    <>
      {allowedGroups.every((allow) => props.permissions.includes(allow)) && (
        <li className={show ? "my-item showMenu" : "my-item"}>
          <div className="my-icon-link">
            <Link to="/">
              <i className="fa-solid fa-truck"></i>
              <span className="my-link_name">Логистика</span>
            </Link>
            <i
              className="fa-solid fa-chevron-down my-arrow"
              onClick={() => setShow(!show)}
            ></i>
          </div>
          <ul className="my-sub-menu">
            <li>
              <Link className="my-link_name" to="/">
                Логистика
              </Link>
            </li>
            <li>
              <Link to="/logorders">Заказы</Link>
            </li>
            {/* <li>
              <Link to="/transfer">Transfer</Link>
            </li> */}
            <li>
              <Link to="/warehouse">Склады</Link>
            </li>
            <li>
              <Link to="/drivers">Курьеры</Link>
            </li>
            <li>
              <Link to="/delivery-methods">Способы доставки</Link>
            </li>
          </ul>
        </li>
      )}
    </>
  );
};

const Sotuv = (props) => {
  const allowedGroups = ["Продажа"];
  const [show, setShow] = useState(false);
  return (
    <>
      {allowedGroups.every((allow) => props.permissions.includes(allow)) && (
        <li className={show ? "my-item showMenu" : "my-item"}>
          <div className="my-icon-link">
            <Link to="/">
              <i className="fa-solid fa-tag"></i>
              <span className="my-link_name">Продажа</span>
            </Link>
            <i
              className="fa-solid fa-chevron-down my-arrow"
              onClick={() => setShow(!show)}
            ></i>
          </div>
          <ul className="my-sub-menu">
            <li>
              <Link className="my-link_name" to="/">
                Продажа
              </Link>
            </li>
            <li>
              <Link to="/order">Заказы</Link>
            </li>
            <li>
              <Link to="/services">Услуги</Link>
            </li>
            <li>
              <Link to="/showroom">Showroom</Link>
            </li>
            <li>
              <Link to="/">Ассистенты</Link>
            </li>
            <li>
              <Link to="/clients">Клиенты</Link>
            </li>
          </ul>
        </li>
      )}
    </>
  );
};

const Info = (props) => {
  const allowedGroups = ["Контент"];
  const [show, setShow] = useState(false);
  return (
    <>
      {allowedGroups.every((allow) => props.permissions.includes(allow)) && (
        <li className={show ? "my-item showMenu" : "my-item"}>
          <div className="my-icon-link">
            <Link to="/">
              <i className="fa-solid fa-circle-info"></i>
              <span className="my-link_name">Инфо</span>
            </Link>
            <i
              className="fa-solid fa-chevron-down my-arrow"
              onClick={() => setShow(!show)}
            ></i>
          </div>

          <ul className="my-sub-menu">
            <li>
              <Link className="my-link_name" to="">
                Инфо
              </Link>
            </li>
            <li>
              <Link to="/main">Главная</Link>
            </li>
            <li>
              <Link to="/banner">Баннеры</Link>
            </li>
            <li>
              <Link to="/opportunity">Преимущества</Link>
            </li>
            <li>
              <Link to="/post">Новости</Link>
            </li>
            <li>
              <Link to="/social">Социальные сети</Link>
            </li>
            <li>
              <Link to="/contact">Контакты</Link>
            </li>
            <li>
              <Link to="/pages">Страницы</Link>
            </li>
          </ul>
        </li>
      )}
    </>
  );
};


const Leads = (props) => {
  const allowedGroups = ["Админ"];
  const [show, setShow] = useState(false);
  return (
    <>
      {allowedGroups.every((allow) => props.permissions.includes(allow)) && (
        <li className={show ? "my-item showMenu" : "my-item"}>
          <div className="my-icon-link">
            <Link to="/">
              <i className="fa-solid fa-hand-holding-hand"></i>
              <span className="my-link_name">Лиды</span>
            </Link>
            <i
              className="fa-solid fa-chevron-down my-arrow"
              onClick={() => setShow(!show)}
            ></i>
          </div>

          <ul className="my-sub-menu">
            <li>
              <Link className="my-link_name" to="">
                Лиды
              </Link>
            </li>
            <li>
              <Link to="/consultetion-leads">Консултация</Link>
            </li>
            <li>
              <Link to="/desinger-leads">От дизайнеров</Link>
            </li>
          </ul>
        </li>
      )}
    </>
  );
};

const PromoCodeAdmin = (props) => {
  const allowedGroups = ["Админ"];
  const [show, setShow] = useState(false);
  return (
    <>
      {allowedGroups.every((allow) => props.permissions.includes(allow)) && (
        <li className={show ? "my-item showMenu" : "my-item"}>
          <div className="my-icon-link">
            <Link to="/">
              <i className="fa-solid fa-ticket"></i>
              <span className="my-link_name">Промокоды</span>
            </Link>
            <i
              className="fa-solid fa-chevron-down my-arrow"
              onClick={() => setShow(!show)}
            ></i>
          </div>

          <ul className="my-sub-menu">
            <li>
              <Link className="my-link_name" to="">
                Промокоды
              </Link>
            </li>
            <li>
              <Link to="/promo-code">Промокоды</Link>
            </li>
          </ul>
        </li>
      )}
    </>
  );
};

export { Main, Analitika, Admin, Katalog, Logistika, Sotuv, Info, Leads, PromoCodeAdmin };
